import { sb } from '../supabase';

// Admin side of the featured catalog (catalog ordering step B, 2026-10-03).
// catalog_featured is readable by admins only (RLS); every write goes through
// the admin_* RPCs, which check is_admin_user() and the 25-slot cap.

export const FEATURED_CAP_FALLBACK = 25;

// Riyadh end-of-day for a YYYY-MM-DD picked in a date input; '' → no end date.
export function endOfRiyadhDay(ymd) {
  return ymd ? new Date(`${ymd}T23:59:59+03:00`).toISOString() : null;
}

// "catalog_featured_cap: 3 slots left, 5 requested" → 3. Anything else → null.
export function slotsLeftFromError(error) {
  const m = /catalog_featured_cap: (\d+) slots left/.exec(error?.message || '');
  return m ? Number(m[1]) : null;
}

export const isActiveFeature = (row, now = new Date()) =>
  !row.featured_until || new Date(row.featured_until) > now;

export async function fetchFeatured() {
  const { data: rows, error } = await sb.from('catalog_featured')
    .select('source, product_id, featured_until, created_at').order('created_at', { ascending: false });
  if (error) throw error;
  const ids = (rows || []).map((r) => r.product_id);
  let products = [];
  if (ids.length) {
    const res = await sb.from('catalog_products_public')
      .select('id, source, name_ar, name_en, image, seller_id, seller_name, seller_name_latin, subcategory').in('id', ids);
    if (res.error) throw res.error;
    products = res.data || [];
  }
  const byKey = new Map(products.map((p) => [`${p.source}:${p.id}`, p]));
  // A featured row whose product left the catalog (hidden, deactivated) keeps
  // no slot (catalog_featured_active_count joins the view) — shown so it can
  // be cleared.
  return (rows || []).map((r) => ({ ...r, product: byKey.get(`${r.source}:${r.product_id}`) || null }));
}

export async function featureProducts(items, untilIso) {
  return sb.rpc('admin_feature_products', { p_items: items, p_until: untilIso });
}
export async function unfeatureProducts(items) {
  return sb.rpc('admin_unfeature_products', { p_items: items });
}
export async function featureSeller(source, sellerId, untilIso) {
  return sb.rpc('admin_feature_seller', { p_source: source, p_seller_id: sellerId, p_until: untilIso });
}

// Sellers whose name matches, with how many catalog products each has.
export async function searchSellers(term) {
  const q = String(term || '').trim().replace(/[%,()]/g, ' ');
  if (q.length < 2) return [];
  const { data, error } = await sb.from('catalog_products_public')
    .select('source, seller_id, seller_name, seller_name_latin')
    .or(`seller_name.ilike.%${q}%,seller_name_latin.ilike.%${q}%`)
    .limit(500);
  if (error) throw error;
  const by = new Map();
  for (const r of data || []) {
    const k = `${r.source}:${r.seller_id}`;
    const cur = by.get(k) || { source: r.source, seller_id: r.seller_id, name: (r.seller_name_latin || '').trim() || r.seller_name, count: 0 };
    cur.count += 1;
    by.set(k, cur);
  }
  return [...by.values()].sort((a, b) => b.count - a.count).slice(0, 12);
}
